<template>
  <div v-html="detailPrintNotification"></div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      detailPrintNotification: null,
    };
  },
  computed: {
    ...mapState({
      getVesselTripId: (state) => state.vesselTripId,
      loading: (state) => state.vesselTrip.loading,
    }),
  },
  created() {
    this.getHtmlPrintNotification();    
  },
  watch: {
    getVesselTripId(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        console.log(newValue);
      }
    },
    loading(loading) {
      if (loading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
  },
  methods: {
    async getHtmlPrintNotification() {
      let id = localStorage.getItem("vesselTripId");
      const vm = this;
      var http = require("http");
      var options = {
        host: "petrol.excise-online.com/vessel_trips/" + id + "/print",
        headers: {
          "x-user-email": "api_noti@pdss.com",
          "x-user-token": "8JryzTm4qrsZJ9r3UCMH",
        },
      };
      var request = await http.request(options, function (res) {
        var data = "";
        res.on("data", function (chunk) {
          data += chunk;
        });
        res.on("end", function () {
          console.log(data);
          const newStr = data.replaceAll( '="/', '="https://petrol.excise-online.com/')
          const newdata = newStr.replaceAll( '=\"/', '=\"https://petrol.excise-online.com/')
          vm.detailPrintNotification = newdata;
        });
      });
      request.on("error", function (e) {
        console.log(e.message);
      });
      request.end();
    },
  },
};
</script>

<style>
/* p {
  margin: 5px 0px;
} */
div {
  font-size: 14px;
}
</style>